import { ActionTypeApi } from '../api/actionTypeApi';
import { ActionType } from '../models/actionType';
import { createImmutableDataFetchStore } from '../utilities/immutableDataFetchStore';

export const useActionTypesStore = createImmutableDataFetchStore<
  ActionType[],
  void
>(() => new ActionTypeApi().getAll());
